module.exports = __webpack_public_path__ + "img/icon-package.776c4872.svg";